export default "__VITE_ASSET__CopPRcix__"